document.addEventListener('DOMContentLoaded', function () {
	const jobOpeningElements = document.querySelectorAll('.current-opening-dropdown.item');
	const applicationComplete = document.querySelector('.application-modal-index');
	const applicationCompleteClose = document.getElementById('complete-close');
	const applicationCompleteCloseButton = document.getElementById('complete-close-button');
	if (applicationCompleteClose) {
		applicationCompleteClose.addEventListener('click', () => {
			document.body.classList.remove('scroll-fix');
			applicationComplete.style.display = 'none';
			window.location.reload();
		});
	}
	if (applicationCompleteCloseButton) {
		applicationCompleteCloseButton.addEventListener('click', () => {
			document.body.classList.remove('scroll-fix');
			applicationComplete.style.display = 'none';
			window.location.reload();
		});
	}
	// Function to validate the file size
	function validateFileSize(fileInput) {
		const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB in bytes
		const fileSize = fileInput.files[0].size;
		return fileSize <= maxSizeInBytes;
	}
	// Function to validate the file format
	function validateFileFormat(fileInput) {
		const allowedFormats = [
			'pdf',
			'doc',
			'docx',
			'ppt',
			'pptx',
			'jpg',
			'jpeg',
			'png',
			'gif',
			'zip',
			'webp',
		];
		const fileName = fileInput.value.toLowerCase();
		const fileExtension = fileName.split('.').pop();
		return allowedFormats.includes(fileExtension);
	}
	function validateForm(
		concentValidation,
		isCheckedConcent,
		fileValidationMessage,
		resumeFile,
		fileSizeValidationMessage,
		fileExsistsValidationMessage,
		selectElement,
	) {
		const resumeInput = resumeFile;
		const requiredInputs = document.querySelectorAll('.contact-dynamic input[required]');
		const fileValidation = fileValidationMessage;
		const checkedValidation = concentValidation;
		const sizeValidation = fileSizeValidationMessage;
		const fileExsists = fileExsistsValidationMessage;
		let empty = true;
		if (selectElement) {
			const selectValue = selectElement.value;
			const text = document.createElement('p');
			text.classList.add('contact-error');
			if (!selectValue) {
				empty = false;
			}
			if (!selectValue && !selectElement.nextElementSibling) {
				empty = false;
				const errorMessage = 'Please fill the required fields';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				selectElement.parentNode.appendChild(text);
			} else if (selectValue && selectElement.nextElementSibling) {
				selectElement.nextElementSibling.remove();
			}
		}

		requiredInputs.forEach(function (input) {
			const isChecked = isCheckedConcent.checked;
			const text = document.createElement('p');
			text.classList.add('contact-error');
			const val = input.value.trim();
			if (input.type !== 'checkbox' && input.type !== 'file' && input.nextElementSibling) {
				input.nextElementSibling.remove();
			}
			if ((val.length === 0 || typeof val === 'undefined') && input.type !== 'file') {
				empty = false;
				const errorMessage = 'Please fill the required fields';
				const textContent = document.createTextNode(errorMessage);
				text.appendChild(textContent);
				input.parentNode.appendChild(text);
			}
			if (!resumeInput.files[0]) {
				fileExsists.style.display = 'block';
				empty = false;
			}
			if (input.type === 'file' && resumeInput.files[0]) {
				fileExsists.style.display = 'none';
				const fileFormat = validateFileFormat(resumeInput);
				const fileSize = validateFileSize(resumeInput);
				if (fileSize === false) {
					sizeValidation.style.display = 'block';
					empty = false;
				} else {
					sizeValidation.style.display = 'none';
				}
				if (fileFormat === false) {
					fileValidation.style.display = 'block';
					empty = false;
				} else {
					fileValidation.style.display = 'none';
				}
			}
			if (input.type === 'checkbox' && !isChecked) {
				empty = false;
				checkedValidation.style.display = 'block';
			} else if (input.type === 'checkbox' && isChecked) {
				checkedValidation.style.display = 'none';
			}
		});
		return empty;
	}

	function showCareerModal(careerModal, form, concentValidation) {
		const validation = concentValidation;
		const careerPopup = careerModal;
		form.classList.add('contact-dynamic');
		careerPopup.style.display = 'block';
		document.body.classList.add('scroll-fix');
		validation.style.display = 'none';
	}

	function hideCareerModal(careerModal, form) {
		const careerPopup = careerModal;
		form.classList.remove('contact-dynamic');
		document.body.classList.remove('scroll-fix');
		careerPopup.style.display = 'none';
	}

	function checkFormValidation(
		careerModal,
		form,
		concentValidation,
		isCheckedConcent,
		fileValidationMessage,
		resumeFile,
		fileSizeValidationMessage,
		fileExsistsValidationMessage,
		selectElement,
		formApplyButtonText,
	) {
		const careerPopup = careerModal;
		const applyButtontext = formApplyButtonText;
		if (
			validateForm(
				concentValidation,
				isCheckedConcent,
				fileValidationMessage,
				resumeFile,
				fileSizeValidationMessage,
				fileExsistsValidationMessage,
				selectElement,
			) === true
		) {
			applyButtontext.textContent = 'Applying...';
			applyButtontext.setAttribute('disabled', true);
			const formdata = new FormData();
			const file = resumeFile.files[0];
			const recaptchaToken = document.getElementById('recaptcha_token');
			formdata.append('file', file); // phpcs:ignore.
			formdata.append('name', form.first_name.value); // phpcs:ignore.
			formdata.append('lastname', form.last_name.value); // phpcs:ignore.
			formdata.append('email', form.email.value); // phpcs:ignore.
			formdata.append('mobile', form.mobile_number.value); // phpcs:ignore.
			formdata.append('experience', form.experience.value); // phpcs:ignore.
			formdata.append('nonce', form.nonce.value); // phpcs:ignore.
			formdata.append('role', form.role.value); // phpcs:ignore.
			formdata.append('location', form.location.value); // phpcs:ignore.
			formdata.append('careerid', form.careerid.value); // phpcs:ignore.
			formdata.append('toMail', form.toMail.value); // phpcs:ignore.
			formdata.append('recaptcha', recaptchaToken.value); // phpcs:ignore.
			formdata.append('action', 'career_form');

			fetch(
				ajaxload_params.ajaxurl, // eslint-disable-line
				{
					method: 'POST',
					body: formdata,
				},
			)
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					return response.json(); // Parse the JSON response
				})
				.then(data => {
					console.log(data);
					if (data.success) {
						careerPopup.style.display = 'none';
						applicationComplete.style.display = 'flex';
						document.body.classList.add('scroll-fix');
					} else {
						console.error('Upload Failed:', data.message);
					}
				})
				.catch(error => {
					console.error('Error:', error);
				});
		}
	}

	function uploadResume(fileInput, fileNameDisplay) {
		const fileName = fileNameDisplay;
		fileInput.click();
		fileInput.addEventListener('change', function () {
			const selectedFile = fileInput.files[0];
			if (selectedFile) {
				fileName.textContent = selectedFile.name;
			} else {
				fileName.textContent = '';
			}
		});
	}
	function copyCareerLink(copyLink) {
		const tooltip = copyLink;
		const link = copyLink.firstChild.getAttribute('href');
		const tempTextarea = document.createElement('textarea');
		tempTextarea.value = link;
		document.body.appendChild(tempTextarea);
		tempTextarea.select();
		document.execCommand('copy');
		document.body.removeChild(tempTextarea);
		tooltip.children[2].style.visibility = 'visible';
		setTimeout(function () {
			tooltip.children[2].style.visibility = 'hidden';
		}, 2000);
	}

	jobOpeningElements.forEach(jobOpeningElement => {
		const formSubmitCurrentOpening = jobOpeningElement.querySelector('#formSubmitCurrentOpening');
		const careerIndexModal = jobOpeningElement.querySelector('.career-modal');
		const form = jobOpeningElement.querySelector('.career-form-index');
		const formSubmit = jobOpeningElement.querySelector('#formSubmitIndex');
		const uploadButton = jobOpeningElement.querySelector('.resume-upload-index');
		const fileNameDisplay = jobOpeningElement.querySelector('#file-name-index');
		const copyLink = jobOpeningElement.querySelectorAll('.copyLink');
		const fileValidationMessage = jobOpeningElement.querySelector('.validated-file');
		const concentValidation = jobOpeningElement.querySelector('.consent-validation-index');
		const isCheckedConcent = jobOpeningElement.querySelector('.consent-index');
		const resumeFile = jobOpeningElement.querySelector('.resume-index');
		const fileSizeValidationMessage = jobOpeningElement.querySelector('.validated-file-size');
		const fileExsistsValidationMessage = jobOpeningElement.querySelector('.validated-file-exsists');
		const selectElement = jobOpeningElement.querySelector('.experience-index');
		const formApplyButtonText = jobOpeningElement.querySelector('.form-button-apply');

		if (concentValidation) {
			concentValidation.style.display = 'none';
		}
		if (fileValidationMessage) {
			fileValidationMessage.style.display = 'none';
		}
		if (fileSizeValidationMessage) {
			fileSizeValidationMessage.style.display = 'none';
		}
		if (fileExsistsValidationMessage) {
			fileExsistsValidationMessage.style.display = 'none';
		}
		copyLink.forEach(function (copy) {
			copy.addEventListener('click', () => {
				copyCareerLink(copy);
			});
		});
		formSubmitCurrentOpening.addEventListener('click', () => {
			showCareerModal(careerIndexModal, form, concentValidation);
		});
		const closeIcon = jobOpeningElement.querySelector('#close-icon-index');
		closeIcon.addEventListener('click', () => {
			hideCareerModal(careerIndexModal, form);
		});
		formSubmit.addEventListener('click', () => {
			checkFormValidation(
				careerIndexModal,
				form,
				concentValidation,
				isCheckedConcent,
				fileValidationMessage,
				resumeFile,
				fileSizeValidationMessage,
				fileExsistsValidationMessage,
				selectElement,
				formApplyButtonText,
			);
		});
		uploadButton.addEventListener('click', () => {
			const fileInput = uploadButton.previousElementSibling;
			uploadResume(fileInput, fileNameDisplay);
		});
	});

	grecaptcha.ready(function () { //eslint-disable-line
		grecaptcha //eslint-disable-line
			.execute(ajaxload_params.recaptchaSiteKey, { action: 'career_form' }) //eslint-disable-line
			.then(function (token) {
				const tokenInput = document.createElement('input');
				tokenInput.type = 'hidden';
				tokenInput.id = 'recaptcha_token';
				tokenInput.name = 'recaptcha_token';
				tokenInput.value = token;
				const recaptchaContainer = document.getElementById('career-recaptcha');
				if (recaptchaContainer) {
					recaptchaContainer.innerHTML = ''; // Clear existing content
					recaptchaContainer.appendChild(tokenInput);
				}
			});
	});
});
